// import { useContext } from '@nuxtjs/composition-api'

export function useWebPushForeground() {
  // const { $fire } = useContext()

  function webPushOnMessage() {
    // if (!$fire.messaging) return
    // $fire.messaging.onMessage((payload: any) => {
    //   console.log('webPushOnMessage', payload)
    // })
  }

  return {
    webPushOnMessage,
  }
}
